import { createContext } from 'react';

interface EditPageContextI {
  setHero: (blobUrl: string | undefined) => void;
}

export const EditPageContext = createContext<EditPageContextI>({
  setHero: () => undefined,
});
